import { XMarkIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useMemo } from "react";

import { useUser } from "@/api/hooks/useUser";

interface TallyFormPopupProps {
  tallyFormUrl: string;
  onComplete: () => void;
  onClose: () => void;
}

const TallyFormPopup: React.FC<TallyFormPopupProps> = ({ tallyFormUrl, onComplete, onClose }) => {
  const user = useUser();

  const urlWithEmail = useMemo(() => {
    if (!tallyFormUrl) {
      return "";
    }
    const url = new URL(tallyFormUrl);
    if (user && user.email) {
      url.searchParams.append("email", user.email);
    }
    return url.toString();
  }, [tallyFormUrl, user]);

  useEffect(() => {
    const handleTallyMessage = (event: MessageEvent) => {
      if (event.origin !== "https://tally.so") {
        return;
      }

      if (typeof event.data === "string") {
        if (event.data.includes("Tally.FormLoaded")) {
          console.log("Tally form loaded.");
        }

        if (event.data.includes("Tally.FormSubmitted")) {
          onComplete();
        }
      }
    };

    window.addEventListener("message", handleTallyMessage);

    return () => {
      window.removeEventListener("message", handleTallyMessage);
    };
  }, [onComplete]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-75" onClick={onClose}>
      <div
        className="relative h-full w-full max-w-4xl rounded-lg bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute right-4 top-4 z-10 text-gray-600 hover:text-gray-900"
          aria-label="Close"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
        <iframe src={urlWithEmail} className="h-full w-full rounded-lg border-0" title="Tally Onboarding Form" />
      </div>
    </div>
  );
};

export default TallyFormPopup;
